import ChevronRightIconSVG from "@/User/Assets/Svgs/ChevronRightWhiteIcon.svg";
import FrontViewSVG from "@/User/Assets/Svgs/FrontView.svg";
import LogoFCIconSVG from "@/User/Assets/Svgs/LogoFCIcon.svg";
import MessageNotifyIconSVG from "@/User/Assets/Svgs/MessageNotifyIcon.svg";
import TopIntroduceSVG from "@/User/Assets/Svgs/TopIntroduce.svg";
import PrimaryButton from "@/User/Components/Buttons/PrimaryButton";
import Checkbox from "@/User/Components/Checkbox";
import FormErrorLabel from "@/User/Components/Form/FormErrorLabel";
import FormInput from "@/User/Components/Form/FormInput";
import Typography from "@/User/Components/Typography";
import { RouteName } from "@/User/Constants/routes";
import { yupResolver } from "@hookform/resolvers/yup";
import { router, usePage } from "@inertiajs/react";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import route from "ziggy-js";
import { emailValidationRules } from "../../Registration/Utils/validationRules";

const TopContent = () => {
    const { control, register, handleSubmit, formState } = useForm({
        defaultValues: {
            email: '',
            is_optin: true,
        },
        resolver: yupResolver(emailValidationRules),
        mode: 'onTouched',
    });

    const { flash } = usePage().props;
    const [isEmailExisted, setIsEmailExisted] = useState(true);
    const [firstInput, setFirstInput] = useState(true);
    const [previousEmail, setPreviousEmail] = useState('');

    const { errors } = formState;

    const submitForm = (data) => {
        setPreviousEmail(data.email);
        setFirstInput(false);

        router.post(route(RouteName.IndexPage), data, {
            onSuccess: () => {
                setIsEmailExisted(true);
            },
        });
    };
    return (
        <>
            <section id='top-content'>
                <div className="h-31.75 md:h-55.5 lg:h-96.25">
                    <div className="h-23.75 md:h-40 lg:h-72.5 bg-gradient-medium-electric-blue-to-marine">
                        <div className="container relative h-full w-full xs:max-w-375px sm:max-w-680px lg:max-w-container">
                            <img
                                src={FrontViewSVG}
                                className="absolute h-28.25 md:h-47 lg:h-345px top-2.5 md:top-4.25 lg:top-8 right-4 sm:right-8 lg:left-0 lg:right-0 w-auto"
                                alt="独立・起業のためのスカウトサービス リラパス"
                            />
                            <div className="absolute h-28.25 md:h-47 lg:h-345px left-4 right-4 sm:left-8 sm:right-8 lg:left-0 lg:right-0 top-2.5 md:top-4.24 lg:top-8" >
                                <Typography variant="h1" className="w-60 md:w-479px lg:w-767px text-white text-xl md:text-40px lg:text-64px !font-bold leading-normal md:leading-less-tight font-noto-serif-jp">新たなビジネスの発見に、スカウトの選択肢。</Typography>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex w-full justify-center md:mb-10">
                    <div className="block relative w-fit mt-1 md:mt-7">
                        <div className="container relative h-full flex justify-center">
                            <div className="scale-100 md:scale-140 w-full max-w-334px h-117px">
                                <img
                                    className="size-full"
                                    src={TopIntroduceSVG}
                                    alt="「スカウト＋自分で探す」の合わせ技で独立・起業を成功に導く"
                                />
                            </div>
                            <Typography
                                variant="h2"
                                className="absolute w-full top-12 md:top-12 text-primary text-xl md:text-3xl leading-normal text-center"
                            >
                                の合わせ技で
                                <br />
                                独立・開業を成功に導く
                            </Typography>
                        </div>
                    </div>
                </div>
                <div className="sm:flex sm:justify-center container">
                    <div className="flex items-center flex-col md:w-680px px-4 py-4 my-2 md:px-8 lg:py-10 border-2 border-primary mt-3 bg-alice-blue-3">
                        <Typography variant="lead" className=" text-xl leading-normal text-center mt-2 text-midnight" >
                            <span className="text-primary">無料</span>
                            で <span className="text-primary">会員登録</span>
                            して <br />
                        </Typography>
                        <Typography variant="base" className="leading-normal text-center text-midnight font-semibold" >
                            スカウトを受け取り <br />
                            独立・起業できる案件を見る
                        </Typography>
                        <form onSubmit={handleSubmit(submitForm)} className="w-full flex justify-center">
                            <div className="w-85.5 max-w-full flex flex-col mb-2">
                                <label htmlFor="email" className="block text-midnight text-sm mt-2 mb-1">
                                    メールアドレス
                                </label>
                                <FormInput name="email"
                                    className="border border-steel-grey p-4 px-3 text-sm rounded-lg h-11.5"
                                    formValidate={{
                                        ...register('email'),
                                        onInput: (e) => {
                                            if (!firstInput) {
                                                setIsEmailExisted(previousEmail === e.target.value);
                                            }
                                        }
                                    }}
                                    isError={errors?.email}
                                    placeholder="メールアドレスを入力してください"
                                />
                                <FormErrorLabel message={errors?.email?.message} />
                                {(flash?.message && !errors?.email && isEmailExisted) && <FormErrorLabel message={flash?.message} />}
                                <div className="w-full my-1">
                                    <Controller
                                        name="is_optin"
                                        control={control}
                                        render={({ field }) => (
                                            <Checkbox
                                                id="is_optin"
                                                label="メール受信を許可する"
                                                className="w-full text-xs text-midnight"
                                                checked={field.value}
                                                name={field.name}
                                                value={true}
                                                attrs={{ autoComplete: 'off' }}
                                                handleChange={(e) => {
                                                    if (e.target.checked) {
                                                        field.onChange(true);
                                                    } else {
                                                        field.onChange(false);
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                                <Typography variant="small" className="text-2xs text-steel-grey w-full mb-2">
                                    ※メール受信を許可すると、リラパスの最新情報をいち早く見られるようになります
                                </Typography>
                                <Typography variant="small" className="text-xss text-center w-full mt-4 mb-2">
                                    <a
                                        href={route(RouteName.RulePage)}
                                        className="text-primary underline underline-offset-1"
                                    >
                                        利用規約
                                    </a>
                                    及び
                                    <a
                                        href={route(RouteName.PrivacyPolicyPage)}
                                        className="text-primary underline underline-offset-1"
                                    >
                                        個人情報の取り扱い
                                    </a>
                                    に
                                </Typography>
                                <PrimaryButton
                                    className="inline-flex gap-1 justify-center items-center px-10 py-4 rounded-lg text-nowrap"
                                    textClass="text-base text-white"
                                    isRounded={true}
                                    roundedClass="roundcontroled-lg"
                                    isShadow={true}
                                    shadowClass="shadow-prussian-blue shadow-entry"
                                >
                                    <span className="leading-none">同意して会員登録する</span>
                                    <span className="bg-lemon rounded px-2 py-0.5 text-primary text-sm leading-tight">
                                        無料
                                    </span>
                                    <span>
                                        <img src={ChevronRightIconSVG} alt="chevron right icon" className="size-6" />
                                    </span>
                                </PrimaryButton>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="container">
                    <div className="flex items-center flex-col px-3 py-6 my-2 md:px-4 lg:py-10 bg-pale-grey shadow-lg shadow-silk-blue-2 rounded-lg">
                        <Typography
                            variant="base"
                            className="text-primary mb-4 md:mt-2 text-center leading-28.8px mx-1"
                        >
                            「リラパス」は、会員登録するだけで、職歴や希望条件に応じて相性の良い企業から直接スカウトが届くサービスです。
                            <br />
                            もちろん、多種多様なフランチャイズ本部、業務委託案件、代理店から気になる案件を探し自ら応募することもできます。
                        </Typography>
                        <div className="flex flex-row gap-4">
                            <div className="flex items-center flex-col shadow-lg shadow-silk-blue-2 rounded flex-1 max-w-335px">
                                <Typography
                                    variant="base"
                                    className="uppercase w-full text-center font-medium text-white py-px bg-primary rounded-tr rounded-tl"
                                >
                                    Point 1
                                </Typography>
                                <img
                                    width={56}
                                    height={56}
                                    src={LogoFCIconSVG}
                                    alt="logo FC icon"
                                    className="mt-4 mb-3"
                                />
                                <Typography
                                    variant="small"
                                    className="uppercase w-full leading-tight px-2 pb-4 text-justify"
                                >
                                    利用者数20万人の「フランチャイズ比較ネット」が抱える
                                    <span className="text-primary font-semibold leading-tight">
                                        掲載本部数を最大限に活用
                                    </span>
                                </Typography>
                            </div>
                            <div className="flex items-center flex-col shadow-lg shadow-silk-blue-2 rounded flex-1 max-w-335px">
                                <Typography
                                    variant="base"
                                    className="uppercase w-full text-center font-medium text-white py-px bg-primary rounded-tr rounded-tl"
                                >
                                    Point 2
                                </Typography>
                                <img
                                    width={56}
                                    height={56}
                                    src={MessageNotifyIconSVG}
                                    alt="message notify icon"
                                    className="mt-4 mb-3"
                                />
                                <Typography
                                    variant="small"
                                    className="uppercase w-full leading-tight px-2 pb-4 text-justify"
                                >
                                    <span className="text-primary font-semibold leading-tight">
                                        掲載企業から直接スカウト
                                    </span>
                                    が届き、説明会や面談までの
                                    <span className="text-primary font-semibold leading-tight">
                                        スムーズなコミュニケーションが可能
                                    </span>
                                </Typography>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </>
    );
};

export default TopContent;
